import KMDA from './views/kmda.c';

export default KMDA;
